/**
 * @generated SignedSource<<bcca1bc645c54a99192966f52b62e701>>
 * @relayHash 4f9e1fc12763ea436c7785c11780ff3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e

import type { ConcreteRequest } from 'relay-runtime';
export type helpObjectSearchResultsQuery$variables = {
  cloudId: string;
  helpCenterAri?: string | null | undefined;
  limit: number;
  queryTerm: string;
};
export type helpObjectSearchResultsQuery$data = {
  readonly helpObjectStore_searchArticles: {
    readonly message?: string;
    readonly results?: ReadonlyArray<{
      readonly ari: string;
      readonly displayLink: string;
      readonly metadata: {
        readonly isExternal: boolean;
      };
      readonly title: string;
    }>;
  } | null | undefined;
  readonly helpObjectStore_searchRequestTypes: {
    readonly message?: string;
    readonly results?: ReadonlyArray<{
      readonly displayLink: string;
      readonly iconUrl: string | null | undefined;
      readonly id: string;
      readonly title: string;
    }>;
  } | null | undefined;
};
export type helpObjectSearchResultsQuery = {
  response: helpObjectSearchResultsQuery$data;
  variables: helpObjectSearchResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryTerm"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v6 = {
  "kind": "Variable",
  "name": "limit",
  "variableName": "limit"
},
v7 = {
  "kind": "Variable",
  "name": "queryTerm",
  "variableName": "queryTerm"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "highlight",
    "value": false
  },
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "title"
},
v10 = {
  "kind": "ScalarField",
  "name": "displayLink"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpObjectStoreArticleSearchResult",
      "kind": "LinkedField",
      "name": "results",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "concreteType": "HelpObjectStoreArticleMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isExternal"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpObjectStoreArticleSearchResults"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "HelpObjectStoreSearchError"
},
v13 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpObjectStoreRequestTypeSearchResult",
      "kind": "LinkedField",
      "name": "results",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    }
  ],
  "type": "HelpObjectStoreRequestTypeSearchResults"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "helpObjectSearchResultsQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticles",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      },
      {
        "args": (v13/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchRequestTypes",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v12/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "helpObjectSearchResultsQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticles",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      },
      {
        "args": (v13/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchRequestTypes",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v14/*: any*/),
          (v12/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e",
    "metadata": {},
    "name": "helpObjectSearchResultsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6a19867fd32836b788744dc62a5ce984";

export default node;
